import * as React from 'react'

import { Box, ScrollContainer, Spinner } from '@factorialco/deprecated-design-system'
import {
  PerformanceAnswersDocument,
  PerformanceReviewerStrategiesStrategyEnum,
  ReviewProcessTargetsManagedByFilterInput,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { AllAnswersTab } from 'modules/performance_process/components/insights/Answers/AllAnswersTab'
import {
  ReviewerStrategyFilter,
  buildReviewerStrategyOptions,
} from 'modules/performance_process/components/insights/Answers/common/ReviewerStrategyFilter'

const Answers: React.FC<{
  reviewId: number
  managedByFilter: ReviewProcessTargetsManagedByFilterInput | undefined
}> = ({ reviewId, managedByFilter }) => {
  const { data, loading } = useQuery(PerformanceAnswersDocument, {
    variables: {
      reviewId: reviewId,
      managedByFilter: managedByFilter,
    },
  })

  const reviewerStrategies = useUnsafeMemo(
    () => buildReviewerStrategyOptions(data?.performance.reviewProcess?.reviewerStrategies ?? []),
    [data]
  )

  const [reviewType, setReviewType] =
    React.useState<PerformanceReviewerStrategiesStrategyEnum>('manager')

  const reviewQuestionnaireByReviewerStrategy =
    data?.performance?.reviewProcess?.questionnaireByReviewerStrategies

  useUnsafeEffect(() => {
    const firstStrategy = reviewerStrategies[0]
    if (firstStrategy) setReviewType(firstStrategy.value)
  }, [reviewerStrategies])

  return (
    <Box overflowY="scroll">
      {loading && (
        <Box minHeight="s400" alignItems="center" justifyContent="center">
          <Spinner />
        </Box>
      )}
      {data && reviewQuestionnaireByReviewerStrategy && (
        <Box gap="s8">
          {reviewerStrategies.length > 0 && (
            <ReviewerStrategyFilter
              value={reviewType}
              options={reviewerStrategies}
              onChange={setReviewType}
            />
          )}
          <ScrollContainer maxHeight="s600">
            <AllAnswersTab
              answersQuery={data}
              reviewQuestionnaireByReviewerStrategy={reviewQuestionnaireByReviewerStrategy}
              reviewType={reviewType}
            />
          </ScrollContainer>
        </Box>
      )}
    </Box>
  )
}

export default observer(Answers)
